import { render } from "./TheLoader.vue?vue&type=template&id=4b81e51e&scoped=true"
import script from "./TheLoader.vue?vue&type=script&lang=js"
export * from "./TheLoader.vue?vue&type=script&lang=js"

import "./TheLoader.vue?vue&type=style&index=0&id=4b81e51e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@5.6.2__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b81e51e"]])

export default __exports__